import { gql } from "../__generated__/gql";

export const RESEND_VERIFICATION_EMAIL = gql(`
    mutation ResendVerificationEmail {
        resendVerificationEmail
    }
`);

export const FIND_MY_MISSIONS = gql(`
    query findMyMissions {
        findMyMissions(limit: 100, offset: 0) {
            elements {
                ...CoreMissionFields
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
`);

export const FIND_WORKER_MISSIONS = gql(`
    query findWorkerMissions($workerProfileId: ID!) {
        findWorkerMissions(workerProfileId: $workerProfileId, limit: 100, offset: 0) {
            elements {
                ...CoreMissionFields
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
`);
